import React from 'react';
import Button from '@mui/material/Button';
import { Divider, FormGroup, Checkbox, Tooltip, FormControlLabel } from '@mui/material';
import { Info } from '@mui/icons-material';
import {
  MainContainer,
  titleStyle,
  Container,
  buttonStyle,
  HeaderContainer,
  TitleContainer,
  tooltipStyle,
  ContainerOptions,
  disabledButtonStyle,
  HeaderContent,
  subtitleStyle,
} from './style';

function Title({
  name,
  subTitle,
  textButton = null,
  buttonDisabled = false,
  check = true,
  setCheck = () => {},
  setUnchanged = () => {},
  checkDisabled = false,
  checkText = '',
  checkInfo = '',
  children,
  setOpenModal,
}) {
  return (
    <MainContainer>
      <HeaderContainer>
        <HeaderContent>
          <TitleContainer>
            <h1 style={titleStyle}>{name}</h1>
          </TitleContainer>
          {subTitle && <p style={subtitleStyle}>{subTitle}</p>}
        </HeaderContent>
        <Container>
          <div style={{ display: 'flex' }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={checkDisabled}
                    checked={check}
                    onChange={() => {
                      setCheck(!check);
                      setUnchanged(false);
                    }}
                  />
                }
                label={checkText}
              />
            </FormGroup>
            <Tooltip title={checkInfo} style={tooltipStyle}>
              <Info />
            </Tooltip>
          </div>
          {textButton ? (
            <Button
              onClick={() => {
                setOpenModal(true);
              }}
              variant="contained"
              color="MexlogGreen"
              style={!buttonDisabled ? buttonStyle : disabledButtonStyle}
              disabled={buttonDisabled}
            >
              {textButton}
            </Button>
          ) : null}
          <ContainerOptions>{children}</ContainerOptions>
        </Container>
      </HeaderContainer>
      <Divider variant="large" style={{ marginBottom: '2rem' }} />
    </MainContainer>
  );
}

export default Title;
